(function() {
    $(document).ready(function() {

        const menuEntries = $('a[data-menu]');
        if (menuEntries.length > 2) {

            window.c24LpCssLoaded.then(function() {
                let iButtonBottom = 10;
                let iMenuBottom = 46;

                function updatePosition() {
                    iButtonBottom = 10;
                    iMenuBottom = 46;

                    const safeAreaBottom = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sab'), 10);
                    const tabBarHeight = 70;

                    iButtonBottom += safeAreaBottom;
                    iMenuBottom += safeAreaBottom;

                    if (!window.c24LpIsApp && window.c24LpIsMobile) {
                        iButtonBottom += tabBarHeight;
                        iMenuBottom += tabBarHeight;
                    }

                    if ($('.social.mobile').length) {
                        iButtonBottom += $('.social.mobile').height();
                        iMenuBottom += $('.social.mobile').height();
                    } else if ($('.jsBottomFixed').length) {
                        iButtonBottom += $('.jsBottomFixed').outerHeight();
                        iMenuBottom += $('.jsBottomFixed').outerHeight();
                    } else if ($('.c24Button.js24FixableTrigger').is(':visible').length) {
                        $.each($('.c24Button.js24FixableTrigger').is(':visible'), function(index, ele) {
                            const $trigger = $(ele);
                            const $ctaWrapper = $trigger.parent('.js24Fixable');

                            if ($ctaWrapper.hasClass('js24Fixed')) {
                                iButtonBottom += $trigger.parent('.js24Fixable.js24Fixed').outerHeight() + 3;
                                iMenuBottom += $trigger.parent('.js24Fixable.js24Fixed').outerHeight() + 3;

                                return false;
                            }
                        });
                    }

                    $('.div24SidebarMenu').css({
                        bottom: iButtonBottom,
                    });

                    $('.mod24SidebarNav').css({
                        bottom: iMenuBottom,
                    });
                }

                updatePosition();

                let html = '<div class="div24SidebarMenu" style="bottom:' + iButtonBottom + 'px">Inhaltsverzeichnis</div>';
                let itemCount = 0;
                let isUlTagOpen = false;

                html += '<aside class="mod24SidebarNav" style="bottom:' + iMenuBottom + 'px"><nav><ul>';

                $.each (menuEntries, function() {
                    const $this = $(this);
                    const id = '#' + $this.attr('id');
                    const caption = $this.data('menu');

                    if ($this.data('deviceoutput') === 'desktop') {
                        return;
                    }

                    if ($this.data('submenu')) {
                        html += '<li class="childItem"><a href="' + id + '">' + $('<div />').html(caption).text() + '</a></li>';
                    } else {
                        if (isUlTagOpen) {
                            html += '</ul></li>';
                            isUlTagOpen = false;
                        }
                        html += '<li><ul><li class="parentItem"><a href="' + id + '">' + $('<div />').html(caption).text() + '</a></li>';
                        isUlTagOpen = true;
                    }

                    itemCount++;
                });


                if (isUlTagOpen) {
                    html += '</ul></li>';
                    isUlTagOpen = false;
                }

                html += '</ul>';

                if (itemCount < 3) {
                    return;
                }

                html += '</nav></aside>';
                html += '<div class="div24SidebarOverlay"></div>';
                $('#c24m-page').append($(html));

                document.addEventListener('scroll', function() {
                    updatePosition();
                }, {
                    passive: true,
                });

                const allParentsItems = $('.mod24SidebarNav .parentItem');
                const allChildrenItems = $('.mod24SidebarNav .childItem');

                $.each(allParentsItems, function () {
                    const childItems = $(this).nextAll('li');
                    if (childItems.length > 0) {
                        $(this).addClass('collapsible');
                    }
                });

                const menu = $('.mod24SidebarNav');
                const overlay = $('.div24SidebarOverlay');

                allChildrenItems.hide();


                $('.mod24SidebarNav .parentItem').not('.collapsible').on('click', function() {
                    closeSidebar($(this));
                });

                $('.mod24SidebarNav .childItem').on('click', function() {
                    closeSidebar($(this));
                });

                $('.mod24SidebarNav .collapsible').on('click', function() {

                    if ($(this).nextAll('.childItem').is(':visible')) {
                        $(this).removeClass('active');
                        hideChildrenOfParent($(this));
                    } else {
                        $(this).addClass('active');
                        showChildrenOfParent($(this));
                    }
                });


                $('.div24SidebarMenu').on('click', function() {
                    const trigger = $(this);

                    if (menu.is(':visible')) {
                        trigger.removeClass('active');
                        menu.slideUp('slow', function() {
                            overlay.stop().fadeOut('slow');
                        });
                    } else {
                        trigger.addClass('active');
                        overlay.stop().fadeIn('slow', function() {
                            menu.stop().slideDown('slow');
                        });
                    }
                });

                $('.div24SidebarOverlay').not('.mod24SidebarNav').on('click',function() {
                    const trigger = $(this);

                    trigger.removeClass('active');
                    menu.stop().slideUp('slow', function() {
                        overlay.stop().fadeOut('slow');
                    });
                });

                function hideChildrenOfParent(parent) {
                    const hideChildItems = parent.nextAll('.childItem');
                    hideChildItems.stop().fadeOut('fast');
                }

                function showChildrenOfParent(parent) {
                    const hideChildItems = parent.nextAll('.childItem');
                    hideChildItems.stop().fadeIn('fast');
                }

                function closeSidebar(element) {
                    const trigger = element;

                    trigger.removeClass('active');
                    menu.slideUp('slow', function() {
                        overlay.stop().fadeOut('slow');
                    });
                }

                document.addEventListener('scroll', function() {
                    if ($(window).scrollTop() < 110) {
                        $('.mod24SidebarNav').slideUp('fast', function() {
                            const menu = $('.div24SidebarMenu');
                            $('.div24SidebarOverlay').stop().fadeOut('fast');
                            menu.removeClass('active');
                            menu.stop().fadeOut('fast');
                        });
                    } else {
                        $('.div24SidebarMenu').stop().fadeIn('fast');
                    }
                }, {
                    passive: true,
                });

            });
        }
    });
})();
